// const EnvConfig = require(`../targets/${process.env?.REACT_APP_ENVIRONMENT || 'default'}/AppConfig.js`)?.default;
import json from '../../package.json';

const runtime = window.__APP_CONFIG__ || {};

export default {
	name: runtime.name || json.productName,
	productName: runtime.productName || json.productName,
	creditCurrency: runtime.creditCurrency || json.creditCurrency,
	creditCurrencyIcon: runtime.creditCurrencyIcon || null,
	pwaLogo: runtime.pwaLogo || '/favicon.ico',
	pwaInstructions: runtime.pwaInstructions,
	colorScheme: {
		light: {
			blue_primary: '4, 85, 163', // #0455A3
			darkblue: '0, 74, 145', // #004A91
			bg_primary: '242, 244, 247', // #F2F4F7
			bg_secondary: '255, 255, 255', // #FFFFFF
			bg_tertiary: '245, 247, 251', // #F5F7FB
			label_primary: '33, 36, 45', // #21242D
			label_secondary: '53, 64, 78', // #35404E
			label_tertiary: '98, 113, 130', // #627182
			separator_nonOpaque: '208, 210, 220', // #D0D2DC
			separator_opaque: '119, 128, 145', // #778091
			fill_primary: '150, 164, 181', // #96A4B5
			red: '255, 59, 48', // #FF3B30
			orange: '255, 149, 0', // #FF9500
			yellow: '255, 204, 0', // #FFCC00
			green: '52, 199, 89', // #34C759
			green2: '11, 141, 87', // #0b8d57
			teal: '90, 200, 250', // #5AC8FA
			blue: '0, 122, 255', // #007AFF
			indigo: '88, 86, 214', // #5856D6
			purple: '175, 82, 222', // #AF52DE
			pink: '255, 45, 85', // #FF2D55
			grey0: '0, 0, 0', // #000000
			grey1: '142, 142, 147', // #8E8E93
			grey2: '174, 174, 178', // #AEAEB2
			grey3: '199, 199, 204', // #C7C7CC
			grey4: '209, 209, 214', // #D1D1D6
			grey5: '229, 229, 234', // #E5E5EA
			grey6: '242, 242, 247', // #F2F2F7
			grey7: '255, 255, 255', // #FFFFFF
			white: '255, 255, 255', // #FFFFFF
			black: '0, 0, 0', // #000000
			BTC: '247, 147, 26', // #F7931A
			TRX: '226, 61, 51', // #E23D33
			'USDT-TRC20': '38, 161, 123', // #26A17B
			AML_outdated: '101, 103, 110', // #65676e
			AML_low: '11, 141, 87',
			AML_medium: '247, 147, 26',
			AML_high: '255, 97, 97',
			AML_unchecked: '208, 210, 220',
		},
		dark: {
			blue_primary: '4, 85, 163', // #0455A3
			darkblue: '0, 74, 145', // #004A91
			bg_primary: '14, 14, 14', // #0E0E0E
			bg_secondary: '28, 28, 30', // #1C1C1E
			bg_tertiary: '44, 44, 46', // #2C2C2E
			label_primary: '255, 255, 255', // #FFFFFF
			label_secondary: '237, 238, 244', // #EDEEF4
			separator_nonOpaque: '64, 64, 71', // #404047
			separator_opaque: '77, 77, 93', // #4D4D5D
			fill_primary: '117, 122, 136', // #757A88
			red: '255, 59, 48', // #FF3B30
			orange: '255, 59, 48', // #FF9500
			yellow: '255, 204, 0', // #FFCC00
			green: '52, 199, 89', // #34C759
			green2: '11, 141, 87', // #0b8d57
			teal: '90, 200, 250', // #5AC8FA
			blue: '0, 122, 255', // #007AFF
			indigo: '88, 86, 214', // #5856D6
			purple: '175, 82, 222', // #AF52DE
			pink: '255, 45, 85', // #FF2D55
			grey0: '255, 255, 255', // #FFFFFF
			grey1: '142, 142, 147', // #8E8E93
			grey2: '99, 99, 102', // #636366
			grey3: '72, 72, 74', // #48484A
			grey4: '58, 58, 60', // #3A3A3C
			grey5: '44, 44, 46', // #2C2C2E
			grey6: '28, 28, 30', // #1C1C1E
			grey7: '0, 0, 0', // #000000
			white: '255, 255, 255', // #FFFFFF
			black: '0, 0, 0', // #000000
			BTC: '247, 147, 26', // #F7931A
			TRX: '226, 61, 51', // #E23D33
			'USDT-TRC20': '38, 161, 123', // #26A17B
			AML_outdated: '101, 103, 110',
			AML_low: '11, 141, 87',
			AML_medium: '247, 147, 26',
			AML_high: '255, 97, 97',
			AML_unchecked: '208, 210, 220',
		},
	},
	apiUrl: 'https://test3.bithide.io:8676/',
	routes: {
		main: '/',
		portfolio: '/portfolio',
		// portfolioId: ':portfolioId',
		// portfolioAssets: 'assets',
		// portfolioHistory: 'history',
		addresses: '/addresses',
		address: '/address',
		createAddress: '/create-address',
		addressAmlDetails: '/address-aml-details',
		amlCheckResult: '/aml-check-result',
		amlHistory: '/aml-history',
		assets: '/assets',
		account: '/account',
		auth: '/auth',
		transactionsHistory: '/transactions-history',
		allWallets: '/all-wallets',
		// welcomePage: '/welcomePage',
		devices: '/devices',
		languages: '/languages',

		signUp: '/sign-up',
		createPin: '/create-pin',
		confirmPin: '/confirm-pin',
		createPassword: '/create-password',
		signIn: '/sign-in',

		recoveryPin: '/recoveryPin',
		recoveryPassword: '/recovery-password',

		enterPin: '/enter-pin',
		verificationEmailPhone: '/verification-EmailPhone',
		confirmCaptcha: '/confirm-captcha',
		stubPage: '/stub-page',

		mainPage: '/main-page',
		send: '/send',
		sendAsset: '/send/asset',
		sendAccount: '/send/address',
		sendRecipient: '/send/recipient',
		sendAmount: '/send/amount',
		asset: '/asset',
		allCards: '/all-cards',

		error: '/error',
		sendPayment: '/send/payment',
		sendConfirm: '/send/confirm',
		receive: '/receive',
		receiveAsset: '/receive/asset',
		receiveAddress: '/receive/address',
		receiveQR: '/receive/shareQR',
		transactionDetails: '/transaction-details',

		billingCurrency: '/billing-currency',
		buyBillingCurrency: '/buy-billing-currency',
		buyBillingAddress: '/buy-billing-currency/buy-billing-address',

		openCard: '/open-card',
		cardDetails: '/card-details',
		amlCheckProgress: '/aml-check-progress',

		verifyDevice: '/verify-device',
		verifyDeviceVerify: '/verify-device/verify',

		chooseCardColor: '/open-card/choose-card-color',
		insertPersonalData: '/open-card/insert-personal-data',
		selectCountryCode: '/select-country-code',

		cardTerms: '/card-terms',
		cardEdit: '/edit-card',
		editPersonalInfo: '/edit-personal-info',
		personalInfo: '/personal-info',

		addCardToWallet: '/add-card-to-wallet',
		periodFilterPage: '/period-filter-page',
		cardSpendingLimits: '/card-spending-limits',

		topUpCard: '/top-up-card',
		topUpCardAccount: '/top-up-card/top-up-card-account',
		topUpCardAmount: '/top-up-card/top-up-card-amount',
		topUpCardConfirm: '/top-up-card/top-up-card-confirm',
		exportTransactions: '/export-transactions',

		amlCheck: '/aml-check',

		closeCard: '/close-card',
		closeCardWithdraw: '/close-card/card-withdraw',
		closeCardWithdrawAccount: '/close-card/card-withdraw-account',
		closeCardConfirm: '/close-card/confirm',

		cardWithdrawal: '/card-withdrawal',
		cardWithdrawalAccount: '/card-withdrawal/card-withdrawal-account',

		accessRestricted: '/access-restricted',
	},
	isEnableDevTools: runtime.isEnableDevTools,
	fiatCardsEnabled: runtime.fiatCardsEnabled,
	supportBotName: 'Sample_SupportName_bot_test',
	subRoutesGenerator: {
		// walletsTab: tab => `/portfolio/${tab}`,
		// portfolioTab: (id, tab) => `/portfolio/${id}/${tab}`,
		// billingCurrencyBuyName: nameCurrency => `/billingCurrency/buy/${nameCurrency}`,
	},
	amlCheckEstimatedTimeInSec: 180,
};
